/**
 * Class StyleWith, for PDP 'Style with...' slick
 */

define([
    'jquery',
    'slick'
], (
    $
) => {
    class StyleWith {

        /**
         * Constructor
         *
         * @param {Object}  config  Configuration options passed in through JSON
         *
         * @returns {null}
         */
        constructor(config) {
            const defaultConfig = {
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1170,
                    settings: { slidesToShow: 4 }
                }, {
                    breakpoint: 1024,
                    settings: { slidesToShow: 3 }
                }, {
                    breakpoint: 768,
                    settings: { slidesToShow: 1 }
                }]
            };
            // Merge default config options and provided config
            /** @type {Object} */
            this.config = { ...defaultConfig, ...config };
            /** @type {jQuery} */
            this.$relatedProductsListContainer = $('.product-items');

            this.attachListeners();
        }

        /**
         * Attach event listeners to elements
         *
         * @returns {null}
         */
        attachListeners() {

            /**
             * Initialize slider
             *
             * @returns {null}
             */
            $(document).ready(() => {
                if (this.$relatedProductsListContainer.length) {
                    this.initializeSlickSlider();
                }
            });

            /**
             * Initial slick event register
             *
             * @returns {null}
             */
            $(document).on("init_slick", () => {
                if (this.$relatedProductsListContainer.length) {
                    this.initializeSlickSlider();
                }
            });
        }

        /**
         * Initialize slick slider
         *
         * @returns {null}
         */
        initializeSlickSlider() {
            this.$relatedProductsListContainer.slick(this.config);
        }
    }

    return (config) => {
        const styleWith = new StyleWith(config);
        return styleWith;
    };
});
